<div class="flexic p-2">
  <rex-avatar small [src]="user.avatar"></rex-avatar>
  <div class="mx-2 leading-none">
    <strong class="block font-semibold text-sm">
      {{ user.full_name }}
    </strong>
  </div>
</div>
